import { registerForm } from "./functions";

const { default: Modal } = require("@components/Modal")

const defaultLine = (label, arr, field) => {
  const value = arr[field]
  if (!value || value === "" || value.length === 0) return;
  const extraPath = `${field}Extra`;
  const extra = arr[extraPath]
  const obsField = `${field}Obs`;
  const obsValue = arr[obsField];
  const res = typeof value === "string" ? value : value.join(", ");
  return <>
    <p className="black">{label}: {res.toLowerCase().includes("outro") ? `${res} - ${extra}` : res}</p>
    {obsValue && obsValue !== "" && <p className="black">Observações: {obsValue}</p>
    }
  </>
}

const thicknessLine = (label, arr, extra) => {
  let res = []
  arr.forEach(element => {
    if (element.thickness && element.thickness > 0) {
      res.push(`${element.type} (${element.thickness} cm)`);
    } else if (element.type === "Outro") {
      res.push(`Outro - ${extra}`)
    } else {
      res.push(element.type);
    }
  });
  if (!res || res.length === 0) return;
  return <p className="black">{label}: {res.join(", ")}</p>
}


const ReviewModal = ({ allData, close, missingMsg, children }) => {
  const { data,
    guardrailGroups,
    floorGroups,
    stairsGroups,
    wallGroups,
    baseboardGroups,
    poolGroups,
    ceilingGroups } = allData;

  return <Modal close={close}>
    <div className="form-review-modal">

      <h2 style={{ color: 'black', marginTop: "0px", marginBottom: "8px" }}>Revisar informações</h2>
      {missingMsg !== 'ok' ? <p className="missing-message">{missingMsg}</p> : ''}

      <h3>Telhado</h3>
      <div className="margin-tier-2">
        {defaultLine("Tipo de telhado", data, "roofType")}
        {defaultLine("Estrutura de telhado", data, "roofStructure")}
        {defaultLine("Tipo de calha", data, "roofGutter")}
      </div>

      <h3>Molduras</h3>
      <div className="margin-tier-2">
        {defaultLine("Material das Molduras", data, 'frameType')}
        {data.extraFrame !== "" && defaultLine("Material extra", data, 'extraFrame')}
      </div>


      <h3>Peitoris</h3>
      <div className="margin-tier-2">
        {defaultLine("Estrutura", data, 'sill')}
        {data.extraFrame !== "" && defaultLine("Material extra", data, 'extraSill')}
      </div>

      <h3>Pergolado</h3>
      <div className="margin-tier-2">
        {defaultLine("Estrutura", data, 'pergola')}
        {data?.pergola?.toLowerCase().includes("concreto") && defaultLine("Acabamento igual do ambiente", data, 'extraFrame')}
      </div>

      <h3>Vagas</h3>
      <div className="margin-tier-2">
        {defaultLine("Estrutura", data, 'parking')}
        {defaultLine("Material", data, 'parkingMat')}
      </div>

      <h3>Rufos</h3>
      <div className="margin-tier-2">
        {defaultLine("Onde considerar rufos", data, 'flashing')}
        {data?.flashing?.includes("Muros acima de altura X") && defaultLine("Muros acima de (CM):", data, 'flashingHeight')}
        {defaultLine("Material", data, 'flashingMats')}
      </div>

      <h3>Soleiras</h3>
      <div className="margin-tier-2">
        {defaultLine("Portas com soleira", data, 'thresholdLocs')}
        {defaultLine("Material", data, 'thresholdMats')}
      </div>

      <h3>Piscina</h3>
      <div className="margin-tier-2">
        {poolGroups.map((group, idx) => {
          return <div key={idx}>
            <p className="black">Grupo {idx + 1}</p>
            <p className="small-reminder">{group.rooms.join(", ")}</p>
            <div className="margin-tier-3">
              {defaultLine("Estrutura", group, 'structure')}
              {defaultLine("Acabamento superior", group, 'upperFinish')}
              {defaultLine("Acabamento Externo", group, 'externalFinish')}
            </div>
          </div>
        })}
      </div>

      <h3>Guarda-corpos</h3>
      <div className="margin-tier-2">
        {guardrailGroups.map((group, idx) => {
          return <div key={idx}>
            <p className="black">Grupo {idx + 1}</p>
            <p className="small-reminder">{group.rooms.join(", ")}</p>
            <div className="margin-tier-3">
              {defaultLine("Tipo de guarda-corpo", group, 'type')}
            </div>
          </div>
        })}
      </div>

      <h3>Escadas</h3>
      <div className="margin-tier-2">
        {stairsGroups.map((group, idx) => {
          return <div key={idx}>
            <p className="black">Grupo {idx + 1}</p>
            <p className="small-reminder">{group.rooms.join(", ")}</p>
            <div className="margin-tier-3">
              {defaultLine("Estrutura", group, 'structure')}
              {thicknessLine("Pré-acabamento dos pisos", group.preFinish, group.preFinishExtra)}
              {defaultLine("Acabamento dos pisos", group, 'finish')}
              {thicknessLine("Pré-acabamento do teto", group.roofPrefinish, group.roofPrefinishExtra)}
              {defaultLine("Acabamento do teto", group, 'roofFinish')}
              {(group?.roofFinish?.toLowerCase() === "pintura" || group?.roofFinish?.toLowerCase() === "textura branca + pintura" || group?.roofFinish?.toLowerCase() === "textura pigmentada") && defaultLine("Cor/Código do Acabamento do teto", group, 'roofFinishColor')}
              {defaultLine("Corrimões", group, 'handrail')}
            </div>
          </div>
        })}
      </div>

      <h3>Pisos</h3>
      <div className="margin-tier-2">
        {floorGroups.map((group, idx) => {
          return <div key={idx}>
            <p className="black">Grupo {idx + 1}</p>
            <div className="margin-tier-3">
              <p className="small-reminder">{group.rooms.join(", ")}</p>
              {thicknessLine("Pré-acabamentos", group.preFinish, group.preFinishExtra)}
              {defaultLine("Acabamento", group, 'finish')}</div>
          </div>
        })}
      </div>

      <h3>Tetos</h3>
      <div className="margin-tier-2">
        {ceilingGroups.map((group, idx) => {
          return <div key={idx}>
            <p className="black">Grupo {idx + 1}</p>
            <p className="small-reminder">{group.rooms.join(", ")}</p>

            <div className="margin-tier-3">
              {thicknessLine("Pré-acabamentos", group.preFinish, group.preFinishExtra)}
              {defaultLine("Acabamento", group, 'finish')}
            </div>
          </div>
        })}
      </div>

      <h3>Paredes</h3>
      <div className="margin-tier-2">
        {wallGroups.map((group, idx) => {
          return <div key={idx}>
            <p className="black">Grupo {idx + 1}</p>
            <p className="small-reminder">{group.rooms.join(", ")}</p>
            <div className="margin-tier-3">
              {thicknessLine("Pré-acabamentos", group.preFinish, group.preFinishExtra)}
              {defaultLine("Acabamento", group, 'finish')}
              {group.hidrWallFinish !== "" && defaultLine("Acabamento de paredes hidráulicas", group, 'hidrWallFinish')}
              {group.isPillarDiff === "Sim" && defaultLine("Pré-acabamento de pilares e vigas", group, 'pillarDiff')}
            </div>
          </div>
        })}
      </div>

      <h3>Rodapés</h3>
      <div className="margin-tier-2">
        {baseboardGroups.map((group, idx) => {
          return <div key={idx}>
            <p className="black">Grupo {idx + 1}</p>
            <p className="small-reminder">{group.rooms.join(", ")}</p>
            <div className="margin-tier-3">
              {defaultLine("Tipo", group, 'type')}
              {defaultLine("Altura", group, 'height')}
            </div>
          </div>
        })}
      </div>
    </div>
    {children}
  </Modal>
}

export default ReviewModal